import React from "react";
import { compose } from "recompose";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { withStyles, WithStyles, createStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
import { SpecificTheme } from "../../../theme/default";

type InfoAreaColor = "primary" | "secondary" | "white" | "black";

type InfoAreaProps = {
  icon: React.ReactType | string;
  title: string;
  description: React.ReactNode;
  iconColor?: InfoAreaColor;
  textColor?: InfoAreaColor;
  vertical?: boolean;
  center?: boolean;
  className?: string;
};

type Props = InfoAreaProps & WithStyles<typeof styles>;

const InfoArea: React.FC<Props> = props => {
  const {
    classes,
    center,
    title,
    description,
    iconColor,
    textColor,
    vertical,
    className
  } = props;
  const iconWrapper = classNames({
    [classes.iconWrapper]: true,
    [classes[iconColor]]: true,
    [classes.iconWrapperVertical]: vertical,
    [classes.center]: center
  });
  const iconClasses = classNames({
    [classes.icon]: true,
    [classes.iconVertical]: vertical
  });
  const infoAreaClasses = classNames({
    [classes.infoArea]: true,
    [className]: className !== undefined
  });
  const infoTitleClasses = classNames(
    {
      [classes[textColor]]: true,
      [classes.center]: center
    },
    classes.title
  );
  const infoDescriptionClasses = classNames(
    {
      [classes[textColor]]: true,
      [classes.center]: center
    },

    classes.description
  );

  let icon = null;
  switch (typeof props.icon) {
    case "string":
      icon = <Icon className={iconClasses}>{props.icon}</Icon>;
      break;
    default:
      icon = <props.icon className={iconClasses} />;
      break;
  }
  return (
    <div className={infoAreaClasses}>
      <div className={iconWrapper}>{icon}</div>
      <div className={classes.descriptionWrapper}>
        <h4 className={infoTitleClasses}>{title}</h4>
        <div className={infoDescriptionClasses}>{description}</div>
      </div>
    </div>
  );
};

InfoArea.defaultProps = {
  iconColor: "primary"
};

const styles = (theme: SpecificTheme) =>
  createStyles({
    infoArea: {
      maxWidth: "360px",
      margin: "0 auto",
      padding: "40px 10px 30px 10px",
      [theme.breakpoints.down("sm")]: {
        padding: "10px"
      }
    },
    iconWrapper: {
      float: "left",
      [theme.breakpoints.only("xl")]: {
        marginTop: "6vh"
      }
      // marginTop: "24px"
      // marginRight: "10px"
    },
    center: {
      textAlign: "center"
    },

    primary: {
      color: theme.palette.primary.main
    },
    secondary: {
      color: theme.palette.secondary.main
    },
    white: {
      color: theme.palette.common.white
    },
    black: {
      color: theme.palette.common.black
    },

    icon: {
      width: "2.25rem",
      height: "2.25rem",
      fontSize: "2.25rem"
    },

    descriptionWrapper: {
      // color: grayColor[0],
      overflow: "hidden"
    },
    title: {
      // ...title,
      margin: "0 0 0.25rem !important",
      minHeight: "unset"
    },
    description: {
      // color: grayColor[0],
      overflow: "hidden",
      marginTop: "0px",
      "& p": {
        // color: grayColor[0],
        fontSize: "14px"
      }
    },
    iconWrapperVertical: {
      float: "none"
    },
    iconVertical: {
      width: "61px",
      height: "61px"
    }
  });

export default compose<Props, InfoAreaProps>(withStyles(styles))(InfoArea);
